/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-unused-state */
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { ViewState, EditingState, ChangeSet } from '@devexpress/dx-react-scheduler';
import {
  Scheduler,
  Toolbar,
  MonthView,
  WeekView,
  ViewSwitcher,
  Appointments,
  AppointmentTooltip,
  AppointmentForm,
  DragDropProvider,
  EditRecurrenceMenu,
  AllDayPanel,
} from '@devexpress/dx-react-scheduler-material-ui';
import { connectProps } from '@devexpress/dx-react-core';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Button as ReactButton } from 'react-bootstrap';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import {LocationOn, Notes, Close, CalendarToday, Create, Stars, SupervisedUserCircle, CheckCircle, Public, Psychology, Map, HighlightOff, AddCircleOutline, Update, Today, InsertInvitation, NightlightRound, EventAvailable} from '@mui/icons-material';
import Checkbox from '@mui/material/Checkbox';
// import LocationOn from '@mui/icons-material/LocationOn';
// import Notes from '@mui/icons-material/Notes';
// import Close from '@mui/icons-material/Close';
// import CalendarToday from '@mui/icons-material/CalendarToday';
// import Create from '@mui/icons-material/Create';
import TextField from '@mui/material/TextField';
import { appointments } from '../../SchedulerScreen/demo-data/appointments';
import { UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables } from '../../../graphql/API';
import { useMutation } from '@apollo/client';
import { updateAgendaShift } from './queries';
import { useCallback, useRef, useState } from 'react';
import { Box, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@mui/material';
import Select from 'react-dropdown-select';
import { FormControl, FormHelperText, InputLabel } from '@mui/material';
import { t } from 'i18next';
import { PUBLIC_ID } from '../../../config';
import { set } from 'date-fns';
import axios from 'axios';
import { useAuthContext } from '../../../contexts/AuthContext';
import { Loader } from '@googlemaps/js-api-loader';
import { jwtDecode } from "jwt-decode";
import CustomModal from '../../../components/Modals/CustomModal';
import { Modal } from 'react-bootstrap';
import { GoogleMap, Marker } from '@react-google-maps/api';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import Cookies from 'js-cookie';


const PREFIX = 'Schedulum-form';
// #FOLD_BLOCK
const classes = {
  content: `${PREFIX}-content`,
  header: `${PREFIX}-header`,
  closeButton: `${PREFIX}-closeButton`,
  buttonGroup: `${PREFIX}-buttonGroup`,
  button: `${PREFIX}-button`,
  picker: `${PREFIX}-picker`,
  wrapper: `${PREFIX}-wrapper`,
  icon: `${PREFIX}-icon`,
  textField: `${PREFIX}-textField`,
  selectField: `${PREFIX}-selectField`,
  addButton: `${PREFIX}-addButton`,
};

// #FOLD_BLOCK
const StyledDiv = styled('div')(({ theme }) => ({
  [`& .${classes.icon}`]: {
    margin: theme.spacing(2, 0),
    marginRight: theme.spacing(2),
  },
  [`& .${classes.header}`]: {
    overflow: 'hidden',
    paddingTop: theme.spacing(0.5),
  },
  [`& .${classes.textField}`]: {
    width: '100%',
  },
  [`& .${classes.selectField}`]: {
    width: '100%',
    minWidth: 400,
    alignSelf: 'start',
    justifyContent: 'start',
  },
  [`& .${classes.content}`]: {
    padding: theme.spacing(2),
    paddingTop: 0,
  },
  [`& .${classes.closeButton}`]: {
    float: 'right',
  },
  [`& .${classes.picker}`]: {
    marginRight: theme.spacing(2),
    '&:last-child': {
      marginRight: 0,
    },
    width: '100%',
  },
  [`& .${classes.wrapper}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0),
  },
  [`& .${classes.buttonGroup}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 2),
  },
  [`& .${classes.button}`]: {
    marginLeft: theme.spacing(2),
  },
}));

interface JWTPayload {
  "cognito:username": string;
}

interface Appointment {
  id?: string;
  title?: string;
  info?: string;
  role?: string;
  user?: string;
  userId: string;
  username: string;
  startDate?: Date;
  endDate?: Date;
  location?: string;
  confirmed?: boolean;
  suspended?: boolean;
  // accepted?: boolean;
  users?: string[];
  notes?: string;
  public?: boolean;
  lat?: string;
  lng?: string;
}

// interface ChangeSet {
//   added?: Appointment;
//   changed?: { [key: number]: Appointment };
//   deleted?: number;
// }

interface AppointmentFormCustomProps {
  visible: boolean;
  visibleChange: () => void;
  appointmentData: Appointment;
  cancelAppointment: () => void;
//   target: HTMLElement | null;
  target: React.RefObject<HTMLElement>;// | null;
  onHide: () => void;
  commitChanges: (changes: ChangeSet) => void;
  onEditingAppointmentChange: (changes: ChangeSet) => void;
  selectOptions?: { id: string; username: string }[];//Array<{ id: string; user: string }>;
  isMulti: boolean;
  removeConfirm: boolean;
  removePublic: boolean;
  // previousPage: (arg: Appointment) => void;
  // nextPage: (arg: Appointment) => void;
//   appointment: Appointment;
}

// interface AppointmentFormCustomState {
//   appointmentChanges: Partial<Appointment>;
// }

const AppointmentFormCustom: React.FC<AppointmentFormCustomProps> = ({
  visible,
  visibleChange,
  appointmentData,
  cancelAppointment,
  target,
  onHide,
  commitChanges,
  onEditingAppointmentChange,
  selectOptions,
  isMulti,
  removeConfirm,
  removePublic,
  // previousPage,
  // nextPage
}) => {
  // console.log(appointmentData);
// class AppointmentFormCustom extends React.PureComponent<
//   AppointmentFormCustomProps,
//   AppointmentFormCustomState
// > {
//   constructor(props: AppointmentFormCustomProps) {
//     super(props);
//     this.state = {
//       appointmentChanges: {},
//     };
//   }
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // PUBLIC STATE
  const [publicShift, setPublicShift] = useState(removePublic ? false : true);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [appointmentChanges, setAppointmentChanges] = useState<Partial<Appointment>>({});
   // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  // GEOLOCATION
  const [coordinates, setCoordinates] = useState({
    latitude: "",
    longitude: "",
    formattedAddress: "",
  });
  const [verifyLocation, setVerifyLocation] = useState(true);
  const [showGeoInput, setShowGeoInput] = useState(false);
  const [selectedMap, setSelectedMap] = useState({
      latitude: 37.78825, // Valeur par défaut (San Francisco)
      longitude: -122.4324,
      latitudeDelta: 0.05, // Ajuster le zoom
      longitudeDelta: 0.05,
  });

  const changeAppointment = useCallback(
    ({ field, changes }: { field: keyof Appointment; changes: any }) => {
      setAppointmentChanges((prev) => ({
        ...prev,
        [field]: changes,
      }));
    },
    []
  );

  const commitAppointment = useCallback(
    (type: "added" | "changed" | "deleted") => {
      const appointment = { ...appointmentData, ...appointmentChanges };

      if (appointment.id) {
        if (type === "deleted") {
          commitChanges({ deleted: appointment.id });
        } else if (type === "changed") {
          commitChanges({ changed: { [appointment.id]: appointment } });
        } else {
          commitChanges({ added: appointment });
        }
        setAppointmentChanges({});
      } else {
        // CREATE (no ID)
        // type == added
        commitChanges({ added: appointment });
      }
    },
    [appointmentChanges, appointmentData, commitChanges]
  );
  // changeAppointment = ({ field, changes }: { field: keyof Appointment; changes: any }) => {
  //   this.setState(prevState => ({
  //     appointmentChanges: {
  //       ...prevState.appointmentChanges,
  //       [field]: changes,
  //     },
  //   }));
  // };

  // commitAppointment = (type: 'added' | 'changed' | 'deleted') => {
  //   const { commitChanges, appointmentData } = this.props;
  //   const { appointmentChanges } = this.state;
  //   const appointment = { ...appointmentData, ...appointmentChanges };

  //   if (appointment.id) {
  //       if (type === 'deleted') {
  //           commitChanges({ deleted: appointment.id });
  //       } else if (type === 'changed') {
  //           commitChanges({ changed: { [appointment.id]: appointment } });
  //       } else {
  //           commitChanges({ added: appointment });
  //       }
  //       this.setState({ appointmentChanges: {} });
  //   }
  // };

  // render() {

    // const { visible, visibleChange, appointmentData, cancelAppointment, target, onHide } = this.props;
    // const { appointmentChanges } = this.state;
    const displayAppointmentData = { ...appointmentData, ...appointmentChanges };
    const isNewAppointment = appointmentData ? appointmentData.id === undefined : undefined;
    
    const [fieldErrors, setFieldErrors] = useState<{ [key in keyof Appointment]?: string }>({});

    const [roleError, setRoleError] = useState(false);
    const [infoError, setInfoError] = useState(false);
    const [locationError, setLocationError] = useState(false);

    if (selectedUsers.length === 0 && appointmentData?.userId && selectOptions?.length > 0) {
      if (!isNewAppointment && appointmentData?.userId === PUBLIC_ID) {
        setPublicShift(true);
        setSelectedUsers([{id: PUBLIC_ID, username: "PUBLIC"}]);
      } else {
        const initialSelected = selectOptions.filter(option => option.id === appointmentData.userId);
        setSelectedUsers(initialSelected);
      }
    }
     
    // const applyChanges = isNewAppointment
    //   ? () => commitAppointment('added')
    //   : () => commitAppointment('changed');
    const applyChanges = () => {
      const errors: { [key in keyof Appointment]?: string } = {};
      // console.log(publicShift)
      // console.log(selectedUsers)
      if (selectedUsers.length === 0) {
        if (!publicShift) {
          errors.users = t('error.users_required');
        } else {
          if (!removePublic) appointmentData.public = true;
        }
      }

      if (!displayAppointmentData.role || displayAppointmentData.role.trim() === '') {
        errors.role = t('error.role_required');
      }

      if (!displayAppointmentData.info || displayAppointmentData.info.trim() === '') {
        errors.info = t('error.info_required');
      }

      if (!displayAppointmentData.location || displayAppointmentData.location.trim() === '') {
        errors.location = t('error.location_required');
      }

      if (Object.keys(errors).length > 0) {
        setFieldErrors(errors);
        return;
      }
    
      setFieldErrors({}); // reset les erreurs

      if (isNewAppointment) {
        commitAppointment('added');
      } else {
        commitAppointment('changed');
      }
    
      // setRoleError(false);
      visibleChange();
    };

    const textEditorProps = (field: keyof Appointment) => ({
        // variant: 'outlined',
        variant: 'outlined' as 'outlined',
        onChange: ({ target: change }: any) => changeAppointment({
          // field: [field], changes: change.value,
          field: field, changes: change.value,
        }),
        value: displayAppointmentData[field] || '',
        label: field[0].toUpperCase() + field.slice(1),
        className: classes.textField,
        error: !!fieldErrors[field],
        helperText: fieldErrors[field] || '',
        // error: field === 'role' ? roleError : false,
        // helperText: field === 'role' && roleError ? 'Le titre est requis' : '',
    });

    const checkboxEditorProps = (field: keyof Appointment) => ({
      // variant: 'outlined',
      // variant: 'outlined' as 'outlined',
      // onChange: ({ target: change }: any) => changeAppointment({
      //   field: field, changes: change.checked,
      // }),
      onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
        changeAppointment({
          field: field, 
          changes: event.target.checked, // ✅ Utilise `checked` de `event.target`
        });
        // if (!removePublic) {
        //   setPublicShift(!publicShift);
        // }
      },
      checked: Boolean(displayAppointmentData[field]),
      // value: displayAppointmentData[field] || '',
      label: field[0].toUpperCase() + field.slice(1),
      className: classes.textField,
    });

    // console.log("Options disponibles:", selectOptions.filter(option => option.id === "144804f8-60c1-70bf-c4b2-ee76f06ddf7d"),);

    // console.log('isMulti', isMulti);
    const selectEditorProps = (field: keyof Appointment, multi: boolean = isMulti) => ({
      
      // variant: 'outlined',
      variant: 'outlined' as 'outlined',
      // onChange: ({ target: change }: any) => 
      onChange: (values: any) => {
        setSelectedUsers(values);
        changeAppointment({ field, changes: values });
      },
      // onChange: (values: any) => console.log('change', values),
      values: selectedUsers.length == 0 ?
        appointmentData?.userId === PUBLIC_ID ?
          [{id: PUBLIC_ID, username: "PUBLIC"}] // [{id: PUBLIC_ID, username: "Public"}]
        :
        selectOptions.filter(option => option.id === appointmentData.userId)
        
          // multi ? 
          //   selectOptions.filter(option => appointmentData.userId.includes(option.id))
          // :
          //   selectOptions.filter(option => option.id === appointmentData.userId)
        :
        selectedUsers,

      options: selectOptions,
    
      // value: selectOptions.filter(option => option.id === "144804f8-60c1-70bf-c4b2-ee76f06ddf7d"),//[{id: "144804f8-60c1-70bf-c4b2-ee76f06ddf7d", username: "sp4rk"}],
      // multi ? 
      //   displayAppointmentData[field] || [] as string[]//selectedUsers || '',//displayAppointmentData[field] || '',
      //   : [{id: "144804f8-60c1-70bf-c4b2-ee76f06ddf7d", username: "sp4rk"}],
        // [selectOptions.find(option => option.id == appointmentData.userId)],
      label: field[0].toUpperCase() + field.slice(1),
      labelField: "username",
      valueField: "id",
      placeholder: "Select workers",
      // onChange: (values: any) => setSelectedUsers(values),
      // addPlaceholder={this.state.addPlaceholder}
      color: "#0074D9",
      // disabled={this.state.disabled}
      // loading={this.state.loading}
      // searchBy={this.state.searchBy}
      // separator={this.state.separator}
      // clearable={this.state.clearable}
      // searchable={this.state.searchable}
      // create={this.state.create}
      // keepOpen={this.state.forceOpen}
      // dropdownHandle={this.state.handle}
      // dropdownHeight={this.state.dropdownHeight}
      // direction={this.state.direction}
      multi: multi,
      // dropdownPosition: "bottom",
      searchable: true,
      searchBy: "username",
      handle: true,
      addPlaceholder: "+ click to add",
      keepSelectedInList: true,
      closeOnSelect: false,
      dropdownPosition: "bottom",
      // direction: "ltr",
      dropdownHeight: "300px",


      noDataLabel: "No matches found",
      className: classes.selectField,
      error: !!fieldErrors[field],
      helperText: fieldErrors[field] || '',
    });

    const radioGroupProps = (field: keyof Appointment) => ({
      // variant: 'outlined',
      variant: 'outlined' as 'outlined',
      onChange: ({ target: change }: any) => changeAppointment({
        // field: [field], changes: change.value,
        field: field, changes: change.value,
      }),
      value: displayAppointmentData[field] || false,
      label: field[0].toUpperCase() + field.slice(1),
      className: classes.textField,
    });

    const pickerEditorProps = (field: keyof Appointment) => ({
        // keyboard: true,
        value: displayAppointmentData[field],
        onChange: (date: any) => changeAppointment({
            field: field, changes: date ? date.toDate() : new Date(displayAppointmentData[field] as Date),
        }),
        ampm: true,
        inputFormat: 'DD/MM/YYYY HH:mm',
        onError: (): null => null,
    });

    const startDatePickerProps = pickerEditorProps('startDate');
    const endDatePickerProps = pickerEditorProps('endDate');

    const cancelChanges = () => {
        setAppointmentChanges({})
        // this.setState({
        //   appointmentChanges: {},
        // });
        visibleChange();
        cancelAppointment();
    };

    // FOR PAGINATION IN MODAL
    // const showMoreUsers = (): Promise<boolean> => {
    //   const btnPrevious = document.querySelector('button[aria-label="Go to previous page"].amplify-button');
    //   const btnNext = document.querySelector('button[aria-label="Go to next page"].amplify-button');
    //   return new Promise((resolve) => { 
    //     setFooterModal(false);
    //     setContentModal(
    //       <>
    //         <Modal.Header closeButton>
    //           <Modal.Title>{t('shift.moreUserTitle')}</Modal.Title>
    //         </Modal.Header>

    //         <Modal.Body>
    //           <p>{t('shift.seeMoreUsers')}</p>
    //         </Modal.Body>
            
    //         <Modal.Footer>
    //           <ReactButton variant="secondary" onClick={() => {
    //             setShowCustomModal(false);
    //             resolve(false);
    //           }}>
    //             {t('shift.cancel')}
    //           </ReactButton>
    //           { (btnPrevious && !(btnPrevious as HTMLButtonElement).disabled) &&
    //             <ReactButton variant="primary" onClick={() => {
    //               // if (btnPrevious) (btnPrevious as HTMLElement).click();
    //               previousPage(!isNewAppointment && appointmentData);
    //               setShowCustomModal(false);
    //               resolve(true);
    //             }}>
    //               {t('shift.previousUser')}
    //             </ReactButton>
    //           }
    //           { (btnNext && !(btnNext as HTMLButtonElement).disabled) &&
    //             <ReactButton variant="primary" onClick={() => {
    //               // if (btnNext) (btnNext as HTMLElement).click();
    //               nextPage(!isNewAppointment && appointmentData);
    //               setShowCustomModal(false);
    //               resolve(true);
    //             }}>
    //               {t('shift.nextUser')}
    //             </ReactButton>
    //           }
    //       </Modal.Footer>
    //       </>
    //     );
    //     setShowCustomModal(true);
    //   });
    // }

    const getLatLngFromAddress = async (address: string): Promise<{ lat: number; lng: number } | null> => {
      const loader = new Loader({
        apiKey: process.env.REACT_APP_GEO_APIKEY,
        libraries: ['places'],
      });

      const google = await loader.load();

      return new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address }, (results, status) => {
          if (status === 'OK' && results && results.length > 0) {
            const location = results[0].geometry.location;
            resolve({ lat: location.lat(), lng: location.lng() });
          } else {
            console.error('Geocoding failed:', status);
            resolve(null);
          }
        });
      });
    };

    const buildDOMerror = (message: string) => {
      const rec = document.getElementById("recommendations");
      const warning = document.createElement('div');
      rec.innerHTML = `<div><h5 class="text-danger">${message}</h5></div>`
      rec.appendChild(warning);
    }

    const isNightShift = (start: Date, end: Date): boolean => {
      const current = new Date(start);

      while (current < end) {
        const hour = current.getHours();
        if (hour >= 0 && hour < 4) {
          return true; // travaille au moins une minute entre 00h et 04h
        }
        current.setMinutes(current.getMinutes() + 1);
      }
      return false;
    }

    const askAIRecommendation =  async () => {
      const shift = {
        'day': 'monday',
        'night': 0,
        'role': 'IT',
        'latitude': 9999,   
        'longitude': 9999
      }

      if (!displayAppointmentData['role']) { alert('You must enter a role'); return };
      if (!displayAppointmentData['startDate']) { alert('You need a start date'); return};
      if (!displayAppointmentData['startDate']) { alert('You need a stop date'); return};
      // if (!displayAppointmentData['location']) { alert('You must enter a location'); return };
      
      // ROLE
      shift.role = displayAppointmentData['role'];
      // DATE
      const startDate = displayAppointmentData['startDate'];
      const stopDate = displayAppointmentData['endDate'];

      // const durationMs = stopDate.getTime() - startDate.getTime();
      // const durationMinutes = Math.floor(durationMs / (1000 * 60));
      
      // const nightStartPM = new Date(startDate);
      // nightStartPM.setHours(17, 0, 0, 0);
      // const nightLimitStartPM = new Date(startDate);
      // nightLimitStartPM.setHours(4, 0, 0, 0);
      // const nightEndAM = new Date(stopDate);
      // nightEndAM.setHours(11, 0, 0, 0);
      // const nightLimitEndAM = new Date(stopDate);
      // nightLimitEndAM.setHours(7, 0, 0, 0);

      const dayIndex = new Date(startDate).getDay(); // 0 = Dimanche, 1 = Lundi, ..., 6 = Samedi

      // if ((startDate >= nightStartPM || startDate < nightLimitStartPM) && (stopDate < nightEndAM || (stopDate > nightLimitEndAM && durationMinutes >= 480))) {
      //   shift.night = 1;
      // }
      if (isNightShift(startDate, stopDate)) {
        shift.night = 1;
      }

      switch(dayIndex) {
        case 0:
          shift.day = "monday"
          break
        case 1:
          shift.day = "monday"
          break
        case 2:
          shift.day = "tuesday"
          break
        case 3:
          shift.day = "wednesday"
          break
        case 4:
          shift.day = "thursday"
          break
        case 5:
          shift.day = "friday"
          break
        case 6:
          shift.day = "saturday"
          break
      }

      // LOCATION
      await getLatLngFromAddress(displayAppointmentData['location'])//'1600 Amphitheatre Parkway, Mountain View, CA')
      .then(coords => {
        if (coords) {
          const latitude = coords.lat;
          const longitude = coords.lng;

          shift.latitude = latitude;
          shift.longitude = longitude;
        }
      });

      // console.log('SHIFT', shift);
      // FOR MOBILE VIEW
      const token = new URLSearchParams(window.location.search).get("token");
      let jwtId = ""
      if (token) {
        const decoded = jwtDecode<JWTPayload>(token);

        jwtId = decoded["cognito:username"];
        // console.log("Cognito User ID:", jwtId);
      } else {
        // console.warn("No token found in URL.");
      }

      try {
        const response = await axios.post("/api/ai_manager/shift_suggestion/", {
          userId: jwtId != "" ? jwtId : AuthUserId,
          shift: shift
        }).then(response => {
          // console.log("ask for worker recommendation:", response.data);
          // const json = JSON.parse(response.data);
          const rec = document.getElementById("recommendations");

          const workers = response.data.results; // ✅ ici, c'est déjà un array d'objets JS
          console.log(workers)
          // Nettoyer le conteneur
          rec.innerHTML = '';

          // className="mt-2 border p-2 rounded-1"
          if (shift.latitude == 9999) {
            const warning = document.createElement('div');
            warning.innerHTML = `<div><h5>${t('shift.noGeolocation')}</h5></div>`
            rec.appendChild(warning);
          }
          const Recommendations = ({ workers }: { workers: any[] }) => (
            <>
              {workers.map((worker: any, index: any) => (
                <div className={classes.wrapper} style={{paddingTop: 10, paddingBottom: 20}}>
                  <Typography fontWeight="bold" className={classes.icon}>
                    {index + 1}
                  </Typography>
                  {/* <Map className={classes.icon} color="action" style={{color: 'darkgreen'}}/> */}
                  <Box
                    style={{width: '95%', marginLeft: 0, backgroundColor: '#efefef', padding: '2.5%'}}
                  >
                    <Box style={{float: 'left'}}>
                      <img
                        src={worker.image 
                          ? `https://amplify-schedulum-4nkh-sa-schedulumdrivebucket775c-nz7dmja1diio.s3.us-east-1.amazonaws.com/public/${worker.image}` 
                          : 'https://schedulum.org/no-avatar.jpg'}
                        width={50}
                        height={50}
                        style={{ borderRadius: '50%' }}
                      />
                    </Box>
                    <Box style={{float: 'left', paddingLeft: 10}}>
                      <Typography variant="body1">{worker.username}</Typography>
                      <Typography variant="body2" fontWeight="bold">Score: { worker.score ? worker.score.toFixed(2): 0}</Typography>
                      {/* { shift.night ?  */}
                        <NightlightRound className={classes.icon} color={(shift.night && worker.night) ? "warning" : "action"} />
                      {/* :
                        null
                      }
                      { shift.day ?  */}
                        <EventAvailable className={classes.icon} color={(shift.day && worker.day) ? "success" : "action"} />
                      {/* :
                        null
                      } */}
                    </Box>
                    <Box>
                      <Box style={{float: 'left', paddingLeft: 10}}>
                        <Typography variant="body1">&nbsp;</Typography>
                        <Typography variant="body2" fontWeight="bold">{t('shift.punctuality')}: </Typography>
                        <Typography variant="body2" fontWeight="bold">{t('shift.performance')}: </Typography>
                        <Typography variant="body2" fontWeight="bold">{t('shift.quality')}: </Typography>
                      </Box>
                      <Box style={{float: 'left', paddingLeft: 10}}>
                        <Typography variant="body1">&nbsp;</Typography>
                        <Typography variant="body2">{worker.predicted_punctuality ? worker.predicted_punctuality.toFixed(2) : 0}</Typography>
                        <Typography variant="body2">{worker.predicted_performance ? worker.predicted_performance.toFixed(2) : 0}</Typography>
                        <Typography variant="body2">{worker.predicted_quality ? worker.predicted_quality.toFixed(2) : 0}</Typography>
                      </Box>
                      <Box style={{float: 'left', paddingLeft: 10}}>
                        <Typography variant="body1">&nbsp;</Typography>
                        <Typography variant="body2" fontWeight="bold">{t('shift.rate')}: </Typography>
                        <Typography variant="body2" fontWeight="bold">{t('shift.honor')}: </Typography>
                        <Typography variant="body2" fontWeight="bold">{t('shift.distance_km')}: </Typography>
                      </Box>
                      <Box style={{float: 'left', paddingLeft: 10}}>
                        <Typography variant="body1">&nbsp;</Typography>
                        <Typography variant="body2">{worker.predicted_rate ? worker.predicted_rate.toFixed(2): 0}</Typography>
                        <Typography variant="body2">{worker.honor_score ? worker.honor_score.toFixed(2) : 0}</Typography>
                        <Typography variant="body2">{worker.distance_km ? worker.distance_km.toFixed(2) : 0}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </div>
              ))}
            </>
          )

          // workers.forEach((worker: any, index: number) => {
          //   const item = document.createElement('div');
          //   item.className = 'worker mt-3 border p-2 rounded-1 bg-light';

          //   item.innerHTML = `
          //       <strong>${index + 1} <img src="${worker.image ? 
          //         `https://amplify-schedulum-4nkh-sa-schedulumdrivebucket775c-j6met6z19khi.s3.us-east-1.amazonaws.com/public/${worker.image}` : 
          //         `https://schedulum.org/no-avatar.jpg`}" width="50"> ${worker.username}</strong><br>
          //       Score: ${worker.score.toFixed(2)}
          //       <br><br>
          //   `;
          //       // <strong>${index + 1} ${worker.username}</strong> (ID: ${worker.userId})<br>
          //       // <img src="/media/${worker.image}" width="50"><br>
          //       // Score: ${worker.score.toFixed(2)}<br>
          //       // Cluster: ${worker.cluster}<br><br></br>
            
          //   rec.appendChild(item);
          // });
          const container = document.getElementById('recommendations');

          if (container) {
            const root = createRoot(container);
            root.render(<Recommendations workers={workers} />);
          }
        })
        return response; // Retourne le client token
      
      } catch (error) {
        console.error("Error when getting AI recommendation :", error);
        // alert(error)
        buildDOMerror(t('shift.AIrecError'));
        return null;
      }
    }

    const handleGeocode = async (formData: any) => {
      // if (!formData) return;
      // if (!formData.location) return;
      if (!formData['location'].trim()) {
        alert(t('signup.error') + "\n\n" + t('shift.errorGeo'));
        return;
      }

      const alertLocation = (old_address: string, new_address: string, lat: string, lng: string): Promise<boolean> => {
        return new Promise((resolve) => { 
          if (old_address != new_address) {
            setFooterModal(false);
            setContentModal(
              <>
                <Modal.Header closeButton>
                  <Modal.Title>{t('shift.addressLocationTitle')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <p>{t('shift.addressLocationMessage')}</p>
                  <div style={{padding: 5, borderColor: 'darkgray', borderWidth: 3, borderStyle: 'dotted'}}>
                    <p><strong>{t('shift.addressLocationMessage1')}</strong>{old_address}</p>
                  </div>
                  <div style={{marginTop: 10, padding: 5, borderColor: 'green', borderWidth: 3, borderStyle: 'dotted'}}>
                    <p><strong>{t('shift.addressLocationMessage2')}</strong>{new_address}</p>
                    <p><strong>{t('shift.geoFoundLatitude')}{lat}</strong></p>
                    <p><strong>{t('shift.geoFoundLongitude')}{lng}</strong></p>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <ReactButton variant="secondary" onClick={() => {
                    setCoordinates(prevCoord => ({
                      ...prevCoord,
                      formattedAddress: old_address,
                      latitude: "",
                      longitude: "",
                    }));
                    changeAppointment({
                      field: 'lat', changes: "",
                    })
                    changeAppointment({
                      field: 'lng', changes: "",
                    })
                    displayAppointmentData['lat'] = "";
                    displayAppointmentData['lng'] = "";
                    setShowCustomModal(false);
                    resolve(false);
                  }}>
                    {t('shift.addressLocationKEEP')}
                  </ReactButton>
                  <ReactButton variant="primary" onClick={() => {
                    setCoordinates(prevCoord => ({
                      ...prevCoord,
                      formattedAddress: new_address,
                      latitude: lat.toString(),
                      longitude: lng.toString(),
                    }));
                    changeAppointment({
                      field: 'location', changes: new_address,
                    })
                    displayAppointmentData['location'] = new_address;
                    setSelectedMap({
                        latitude: parseFloat(lat), // Valeur par défaut (San Francisco)
                        longitude: parseFloat(lng),
                        latitudeDelta: 0.05, // Ajuster le zoom
                        longitudeDelta: 0.05,
                    });
                    changeAppointment({
                      field: 'lat', changes: lat.toString(),
                    })
                    changeAppointment({
                      field: 'lng', changes: lng.toString(),
                    })
                    displayAppointmentData['lat'] = lat.toString();
                    displayAppointmentData['lng'] = lng.toString();
                    setShowCustomModal(false);
                    resolve(true);
                  }}>
                    {t('shift.addressLocationUSE')}
                </ReactButton>
              </Modal.Footer>
              </>);
            setShowCustomModal(true);
            // { cancelable: false };
          } else {
            resolve(true);
          }
        });
      }

      // const alertGeo = (lat: string, lng: string): Promise<boolean>=> {
      //   return new Promise((resolve) => { 
      //     setFooterModal(false);
      //     setContentModal(
      //       <>
      //         <Modal.Header closeButton>
      //           <Modal.Title>{t('shift.geoFoundTitle')}</Modal.Title>
      //         </Modal.Header>

      //         <Modal.Body>
      //           <h5>{t('shift.geoFoundMessage')}</h5>
      //           <p>{t('shift.geoFoundMessage1')}</p>
      //           <p>{`${t('shift.geoFoundLatitude')}${lat}`}</p>
      //           <p>{`${t('shift.geoFoundLongitude')}${lng}`}</p>
      //         </Modal.Body>
      //         <Modal.Footer>
      //         <ReactButton variant="secondary" onClick={() => {
      //           setShowGeoInput(false);
      //           setCoordinates(prevCoord => ({
      //             ...prevCoord,
      //             latitude: "",
      //             longitude: "",
      //           }));
      //           changeAppointment({
      //             field: 'lat', changes: "",
      //           })
      //           changeAppointment({
      //             field: 'lng', changes: "",
      //           })
      //           displayAppointmentData['lat'] = "";
      //           displayAppointmentData['lng'] = "";
      //           resolve(false);
      //         }}>
      //           {t('shift.geoFoundDONT')}
      //         </ReactButton>
      //         <ReactButton variant="primary" onClick={() => {
      //           setCoordinates(prevCoord => ({
      //             ...prevCoord,
      //             latitude: lat.toString(),
      //             longitude: lng.toString(),
      //           }));
      //           setSelectedMap({
      //               latitude: parseFloat(lat), // Valeur par défaut (San Francisco)
      //               longitude: parseFloat(lng),
      //               latitudeDelta: 0.05, // Ajuster le zoom
      //               longitudeDelta: 0.05,
      //           });
      //           changeAppointment({
      //             field: 'lat', changes: lat.toString(),
      //           })
      //           changeAppointment({
      //             field: 'lng', changes: lng.toString(),
      //           })
      //           displayAppointmentData['lat'] = lat.toString();
      //           displayAppointmentData['lng'] = lng.toString();
      //           setShowCustomModal(false);
      //           resolve(true);
      //         }}>
      //           {t('shift.geoFoundUSE')}
      //         </ReactButton>
      //       </Modal.Footer>
      //       </>);
      //     setShowCustomModal(true);
      //     // { cancelable: false };
      //   });
      // }

      try {
        const encodedAddress = encodeURIComponent(formData.location);
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${process.env.REACT_APP_GEO_APIKEY}`;

        const response = await fetch(url);
        const geoData = await response.json();

        if (geoData.status === 'OK') {
          if (geoData.results && geoData.results.length > 0) {
            const loc = geoData.results[0].geometry.location;
            let isNewLocation = false;
            // let keepGeo = true;
            // if (formData.location != geoData.results[0].formatted_address) {
            if (geoData.results[0].formatted_address) {
              isNewLocation = await alertLocation(formData.location, geoData.results[0].formatted_address, loc.lat.toString(), loc.lng.toString())
            }
            // if (!isNewLocation) {
            // keepGeo = await alertGeo(loc.lat.toString(), loc.lng.toString());
            // }
            const newCoordinates = {
              latitude: isNewLocation ? loc.lat.toString() : "", // formData.lat,
              longitude: isNewLocation ? loc.lng.toString() : "", // formData.lng,
              formattedAddress: isNewLocation ? geoData.results[0].formatted_address : formData.location
            };
            // if (!keepGeo) return "MODIFY"; // to add custom geolocalisation
            return newCoordinates
          } else {
            return null;
          }
        } else {
          console.log('API Error:', geoData);
          return null;
        }
      } catch (error) {
        console.log('Network Error:', error as Error);
        return null;
      // } finally {
      }
    };

    const getGeoData = async () => {
      const formData = displayAppointmentData; //textEditorProps('location');

      if (!formData['location']) {
        setFooterModal(true);
        setContentModal(
          <>
            <Modal.Header closeButton>
              <Modal.Title>{t('signup.error')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{t('shift.errorGeo')}</Modal.Body>
          </>);
        setShowCustomModal(true);
        return;
      }
      const alertGeo = () => {
        setFooterModal(true);
        setContentModal(
          <>
            <Modal.Header closeButton>
              <Modal.Title>{t('shift.addressNotFoundTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{t('shift.addressNotFoundMessage')}</Modal.Body>
          </>);
        setShowCustomModal(true);
      }

      const geoResponse = await handleGeocode(formData);
      if (geoResponse) {
        // if (geoResponse == "MODIFY") return;
        setCoordinates({
          latitude: geoResponse.latitude, 
          longitude: geoResponse.longitude, 
          formattedAddress: geoResponse.formattedAddress
        });
        const newData = displayAppointmentData;
        if (newData['lat'] && newData['lng']) setShowGeoInput(true);
        return
      } else {
        alertGeo();
        return
      }
    }

    return (
      <>
        <CustomModal
          show={showCustomModal}
          onHide={() => setShowCustomModal(false)}
          link={linkModal}
          children={contentModal}
          isFooter={footerModal}
        />
        <AppointmentForm.Overlay visible={visible} target={target} fullSize={false} onHide={onHide} inert={!visible}>

        {/* <AppointmentForm.Overlay visible={visible} target={target} fullSize onHide={onHide} inert={!visible}>
        <AppointmentForm.Overlay visible={visible} target={target && target.current ? target : undefined} fullSize onHide={onHide}> */}

          <StyledDiv>
            <div className={classes.header}>
              <IconButton className={classes.closeButton} onClick={cancelChanges} size="large">
                <Close color="action" />
              </IconButton>
            </div>
            <div className={classes.content}>
              {removePublic === false ?
                <>
                  {/* <div className={classes.wrapper}>
                    <Public className={classes.icon} color="action" style={{color: '#217a6c'}}/>
                      <FormControlLabel
                        className={classes.selectField}
                        control={<Checkbox {...checkboxEditorProps("public")} />}
                        label={t('shift.publicRadio')}
                        labelPlacement="start"
                        sx={{
                          mt: 1.5, // ou paddingTop: '12px' pour ajuster verticalement
                          alignItems: 'center',
                          marginLeft: 0,
                          '& .MuiFormControlLabel-label': {
                            minWidth: 300,
                            margin: 0,
                            padding: 0,
                          },
                          '& .MuiCheckbox-root': {
                            marginLeft: 0,
                            padding: '4px',
                            width: 50
                          },
                          '& .MuiTypography-root': {
                            display: 'flex',
                            alignItems: 'center',
                          },
                        }}
                        // {{ '& .MuiFormControlLabel-label': { flexWrap: 'row', minWidth: 350},
                        //   '& .MuiCheckbox-root': {
                        //     marginLeft: 0, // supprime l'espace entre label et checkbox
                        //     marginRight: 8, // optionnel : tu peux ajouter un petit espace à droite du label
                        //   }, 
                        // }}
                      />
                  </div> */}
                  {/* <div className={classes.wrapper}>
                    <Public className={classes.icon} color="action" style={{color: '#217a6c'}}/> */}
                    {/* <div className={classes.radioField}> */}
                      {/* <FormControlLabel
                        className={classes.selectField}
                        control={<Checkbox {...checkboxEditorProps("public")} />}
                        label={t('shift.publicRadio')}
                        labelPlacement="start"
                        sx={{
                          mt: 1.5, // ou paddingTop: '12px' pour ajuster verticalement
                          alignItems: 'center',
                          marginLeft: 0,
                          '& .MuiFormControlLabel-label': {
                            minWidth: 300,
                            margin: 0,
                            padding: 0,
                          },
                          '& .MuiCheckbox-root': {
                            marginLeft: 0,
                            padding: '4px',
                            width: 50
                          },
                          '& .MuiTypography-root': {
                            display: 'flex',
                            alignItems: 'center',
                          },
                        }}
                        // {{ '& .MuiFormControlLabel-label': { flexWrap: 'row', minWidth: 350},
                        //   '& .MuiCheckbox-root': {
                        //     marginLeft: 0, // supprime l'espace entre label et checkbox
                        //     marginRight: 8, // optionnel : tu peux ajouter un petit espace à droite du label
                        //   }, 
                        // }}
                      /> */}
                    
                      {/* <label style={{flexWrap: 'wrap',
                        width: 'auto',
                        alignSelf: "center"}}>{t('shift.publicRadio')}</label>
                      <div style={{display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",}}
                      >
                        <input
                          type="checkbox"
                          checked={publicShift ? true : false}
                          onChange={() => setPublicShift(!publicShift)}
                        />
                    </div> */}

                  {/* </div> */}

                  { !publicShift &&
                    <div className={classes.wrapper}>
                      {/* <Select
                        options={selectOptions}
                        labelField="user"
                        valueField="id"
                        onChange={(values) => setSelectedUsers(values)} 
                        values={[]}              
                      />; */}
                      <SupervisedUserCircle className={classes.icon} color="action" style={{color: 'darkblue'}}/>
                      {/* <Select
                        {...selectEditorProps('users')}
                        dropdownPosition="bottom"
                      /> */}
                      <FormControl
                        className={classes.selectField}
                        error={!!fieldErrors.users}
                        style={{paddingTop: 10}}
                      >
                        {/* <InputLabel shrink>{t('Users')}</InputLabel><br/> */}
                        <Select {...selectEditorProps('users')} dropdownPosition="bottom" />
                        {fieldErrors.users && (
                          <FormHelperText>{fieldErrors.users}</FormHelperText>
                        )}
                      </FormControl>
                    </div>
                  }
                </>
              :
                appointmentData?.userId != PUBLIC_ID &&
                  <div className={classes.wrapper}>
                    {/* <Select
                      options={selectOptions}
                      labelField="user"
                      valueField="id"
                      onChange={(values) => setSelectedUsers(values)} 
                      values={[]}              
                    />; */}
                    <SupervisedUserCircle className={classes.icon} style={{color: 'darkblue'}} />
                    {/* <SupervisedUserCircle className={classes.icon} style={{color: 'darkblue'}} onClick={showMoreUsers}/> */}
                    {/* <Select
                      {...selectEditorProps('users')}
                      dropdownPosition="bottom"
                    /> */}
                    <FormControl
                      className={classes.selectField}
                      error={!!fieldErrors.users}
                      style={{paddingTop: 10}}
                    >
                      {/* <InputLabel shrink>{t('Users')}</InputLabel><br/> */}
                      <Select {...selectEditorProps('users')} dropdownPosition="bottom"/>
                      {fieldErrors.users && (
                        <FormHelperText>{fieldErrors.users}</FormHelperText>
                      )}
                    </FormControl>
                    {/* // values={selectedUsers}
                    // options={selectOptions}
                    // handleKeyDownFn={({ event, state, props, methods, setState }) => {
                    //   const { cursor } = state;
                    //   const escape = event.key === 'Escape';
                    //   const enter = event.key === 'Enter';
                    //   const arrowUp = event.key === 'ArrowUp';
                    //   const arrowDown = event.key === 'ArrowDown';
                    //   const tab = event.key === 'Tab' && !event.shiftKey;
                    //   const shiftTab = event.shiftKey && event.key === 'Tab';

                    //   if ((arrowDown || tab) && cursor === null) {
                    //     return setState({
                    //       cursor: 0
                    //     });
                    //   }

                    //   if (arrowUp || arrowDown || shiftTab || tab) {
                    //     event.preventDefault();
                    //   }

                    //   if (escape) {
                    //     this.dropDown('close');
                    //   }

                    //   if (enter) {
                    //     const currentItem = methods.searchResults()[cursor];
                    //     if (currentItem && !currentItem.disabled) {
                    //       if (props.create && valueExistInSelected(state.search, state.values, props)) {
                    //         return null;
                    //       }

                    //       methods.addItem(currentItem);
                    //     }
                    //   }}

                    // placeholder="Select peoples"

                    // addPlaceholder={this.state.addPlaceholder}
                    // color={this.state.color}
                    // disabled={this.state.disabled}
                    // loading={this.state.loading}
                    // searchBy={this.state.searchBy}
                    // separator={this.state.separator}
                    // clearable={this.state.clearable}
                    // searchable={this.state.searchable}
                    // create={this.state.create}
                    // keepOpen={this.state.forceOpen}
                    // dropdownHandle={this.state.handle}
                    // dropdownHeight={this.state.dropdownHeight}
                    // direction={this.state.direction}
                    multi={this.state.multi}

                    // values={[]}//[selectOptions.find((opt) => opt.username === "Sp4rkplug")]}
                    // labelField="username"//{this.state.labelField}
                    // valueField="id"//{this.state.valueField}
                    // options={selectOptions}
                    // dropdownGap={5}

                    // keepSelectedInList={this.state.keepSelectedInList}
                    // onDropdownOpen={() => undefined}
                    // onDropdownClose={() => undefined}
                    // onClearAll={() => undefined}
                    // onSelectAll={() => undefined}

                    // onChange={(values) => setSelectedUsers(values)}
                    // noDataLabel="No matches found"

                    // closeOnSelect={this.state.closeOnSelect}
                    // noDataRenderer={
                    //   this.state.noDataRenderer
                    //     ? () => this.noDataRenderer()
                    //     : undefined
                    // }
                    // dropdownPosition={this.state.dropdownPosition}
                    // itemRenderer={
                    //   this.state.itemRenderer
                    //     ? (item, itemIndex, props, state, methods) =>
                    //         this.itemRenderer(item, itemIndex, props, state, methods)
                    //     : undefined
                    // }
                    // inputRenderer={
                    //   this.state.inputRenderer
                    //     ? (props, state, methods) =>
                    //         this.inputRenderer(props, state, methods)
                    //     : undefined
                    // }
                    // optionRenderer={
                    //   this.state.optionRenderer
                    //     ? (option, props, state, methods) =>
                    //         this.optionRenderer(option, props, state, methods)
                    //     : undefined
                    // }
                    // contentRenderer={
                    //   this.state.contentRenderer
                    //     ? (innerProps, innerState) =>
                    //         this.contentRenderer(innerProps, innerState)
                    //     : undefined
                    // }
                    // dropdownRenderer={
                    //   this.state.dropdownRenderer
                    //     ? (innerProps, innerState, innerMethods) =>
                    //         this.dropdownRenderer(
                    //           innerProps,
                    //           innerState,
                    //           innerMethods
                    //         )
                    //     : undefined
                    // }
                    // /> */}
                  </div>
              }
              <div className={classes.wrapper}>
                <Stars className={classes.icon} color="action" style={{color: '#b35671'}}/>
                <TextField
                  {...textEditorProps('role')}
                />
              </div>
              <div className={classes.wrapper}>
                <Create className={classes.icon} color="action" style={{color: '#fcba03'}}/>
                <TextField
                  {...textEditorProps('info')}
                />
              </div>
              {/* <TextField
                  label="Title"
                  variant="outlined"
                  value={displayAppointmentData.title || ''}
                  onChange={(e) => this.changeAppointment({ field: 'title', changes: e.target.value })}
              /> */}
              <div className={classes.wrapper}>
                  <Today className={classes.icon} color="action"/>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DateTimePicker
                          components={{
                            OpenPickerIcon: Today,
                          }}
                          label="Start Date"
                          renderInput={
                          props => <TextField className={classes.picker} {...props} style={{width: '100%'}}/>
                          // props => <TextField {...props} />

                          }
                          {...startDatePickerProps}
                      />
                      </LocalizationProvider>
                    </div>
                    <div className={classes.wrapper}>
                      <InsertInvitation className={classes.icon} color="action"/>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DateTimePicker
                          label="End Date"
                          renderInput={
                          props => <TextField className={classes.picker} {...props} style={{width: '100%'}}/>
                          // props => <TextField {...props} />

                          }
                          {...endDatePickerProps}
                      />
                  </LocalizationProvider>
              </div>
              
              {/* <DateTimePicker
              label="Start Date"
              value={displayAppointmentData.startDate}
              onChange={(date) => this.changeAppointment({ field: 'startDate', changes: date?.toDate() })}
              onChange={(date) => this.changeAppointment({ field: 'startDate', changes: date?.toISOString() })}

              /> */}
              <div className={classes.wrapper}>
                <LocationOn className={classes.icon} color="action" style={{color: 'maroon'}}/>
                <TextField
                  {...textEditorProps('location')}
                />
              </div>

              <div className={classes.wrapper} style={{paddingTop: 10, paddingBottom: 20}}>
                <Map className={classes.icon} color="action" style={{color: 'darkgreen'}}/>
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.button}
                  style={{width: '100%', marginLeft: 0}}
                  onClick={async () => await getGeoData()}
                >
                  {t('shift.getGeoData')}
                </Button>
              </div>

              <div style={showGeoInput ? {width: '100%'} : {display: 'none'}}>
                <div style={{display: 'none'}}>
                  <div className={classes.wrapper}>
                    <LocationOn className={classes.icon} color="action" />
                    <TextField
                      {...textEditorProps('lat')}
                    />
                  </div>
                  

                  <div className={classes.wrapper}>
                    <LocationOn className={classes.icon} color="action" />
                    <TextField
                      {...textEditorProps('lng')}
                    />
                  </div>
                </div>

                <div className={classes.wrapper} style={{paddingTop: 10, paddingBottom: 20}}>
                  <Typography fontWeight="bold" className={classes.icon}>
                    <Map className={classes.icon} color="action" style={{color: 'darkgreen'}}/>
                  </Typography>
                  
                  <Box
                    style={{width: '95%', marginLeft: 0, backgroundColor: '#efefef', padding: '2.5%', borderRadius: 5}}
                  >
                    <Box style={{float: 'left'}}>
                      <Typography variant="body1" fontWeight="bold">{t('shift.latitude')}: </Typography>
                      <Typography variant="body1" fontWeight="bold">{t('shift.longitude')}: </Typography>
                    </Box>
                    <Box style={{float: 'left', paddingLeft: 20}}>
                      <Typography variant="body1">{coordinates.latitude}</Typography>
                      <Typography variant="body1">{coordinates.longitude}</Typography>
                    </Box>
                  </Box>
                </div>

                {/* <div style={{
                  flexDirection: "row",
                  alignSelf: "stretch",
                  alignItems: "center",
                  marginTop:5,
                  marginBottom: 5}}
                >
                  <span style={{width:75}}>{t('shift.latitude')}</span>
                  <div style={{flex:1}}>
                    <p>{coordinates.latitude}</p>
                  </div>
                </div>
                <div style={{
                  flexDirection: "row",
                  alignSelf: "stretch",
                  alignItems: "center",
                  marginTop:5,
                  marginBottom: 5}}
                >
                  <span style={{width:75}}>{t('shift.longitude')}</span>
                  <div style={{flex:1}}>
                    <p>{coordinates.longitude}</p>
                  </div>
                </div> */}

                <div style={{ padding: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <GoogleMap
                    mapContainerStyle={{
                      width: '300px',
                      height: '300px',
                      marginTop: '10px',
                      marginBottom: '10px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    center={{
                      lat: selectedMap.latitude,
                      lng: selectedMap.longitude
                    }}
                    zoom={15}
                    options={{
                      zoomControl: true,
                      streetViewControl: false,
                      mapTypeControl: false,
                      fullscreenControl: false,
                    }}
                  >
                    <Marker
                      position={{
                        lat: selectedMap.latitude,
                        lng: selectedMap.longitude
                      }}
                      title="Emplacement"
                    />
                  </GoogleMap>
                </div>
              </div>

              {isNewAppointment &&
                <div className={classes.wrapper} style={{paddingTop: 10, paddingBottom: 20}}>
                <Psychology className={classes.icon} color="action" style={{color: '#cf7215'}}/>
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.button}
                  style={{width: '100%', marginLeft: 0}}
                  onClick={() => {
                    askAIRecommendation();
                  }}
                >
                  {t('shift.ai_rec_button')}
                </Button>
              </div>
              }
              <div id="recommendations" className="mt-2 w-100"></div>

              { removeConfirm === false &&
                <div className={classes.wrapper}>
                  <CheckCircle className={classes.icon} color="action" />
                  <FormControlLabel
                    control={<Checkbox {...checkboxEditorProps("confirmed")} />}
                    label="Confirmed"
                    labelPlacement="start"
                  />
                </div>
              }
              {/* <div className={classes.wrapper}>
                <LocationOn className={classes.icon} color="action" />
                <FormControlLabel
                  control={<Checkbox {...checkboxEditorProps("suspended")} />}
                  label="Suspended"
                  labelPlacement="start"
                />
              </div> */}
              {/* <div className={classes.wrapper}>
                <Stars className={classes.icon} color="action" />
                <FormLabel id="demo-radio-buttons-group-label">Confirm</FormLabel>
                <RadioGroup
                {...radioGroupProps('confirmed')} /> */}
                {/* //   aria-labelledby="demo-radio-buttons-group-label"
                //   defaultValue="false"
                //   name="radio-buttons-group"
                // >
                //   <FormControlLabel value="true" control={<Radio />} label="Confirm" />
                //   <FormControlLabel value="false" control={<Radio />} label="Unconfirm" />
                // </RadioGroup> */}
                {/* <Radio
                  {...textEditorProps('role')}
                /> */}
              {/* </div> */}
              {/* <div className={classes.wrapper}>
                <Notes className={classes.icon} color="action" />
                <TextField
                  {...textEditorProps('notes')}
                  multiline
                  rows="6"
                />
              </div> */}
            {/* </div> */}
            {/* <Button onClick={() => this.commitAppointment(isNewAppointment ? 'added' : 'changed')}>
              {isNewAppointment ? 'Create' : 'Save'}
            </Button> */}
            {/* <div className={classes.buttonGroup}> */}
              {!isNewAppointment && (
                <div className={classes.wrapper} style={{paddingTop: 10, paddingBottom: 20}}>
                  <HighlightOff className={classes.icon} color="secondary" />
                  <Button
                    variant="outlined"
                    color="secondary"
                    className={classes.button}
                    style={{width: '100%', marginLeft: 0}}
                    onClick={() => {
                      visibleChange();
                      commitAppointment('deleted');
                    }}
                  >
                    {t('shift.delete')}
                  </Button>
                </div>
              )}
              <div className={classes.wrapper} style={{paddingTop: 10, paddingBottom: 20}}>
                { isNewAppointment ? 
                  <AddCircleOutline className={classes.icon} color="success" />
                :
                  <Update className={classes.icon} color="success" />
                }
                <Button
                variant="outlined"
                color="success"
                className={classes.button}
                style={{width: '100%', marginLeft: 0}}
                onClick={() => {
                  // visibleChange();
                  applyChanges();
                }}
              >
                {isNewAppointment ? t('shift.create') : t('shift.save')}
              </Button>
              </div>
            {/* </div> */}
          </div>
          </StyledDiv>
        </AppointmentForm.Overlay>
      </>
    );
  // }
}

export default AppointmentFormCustom;
